export const RECIPE_API = 'https://forkify-api.herokuapp.com/api';
